import { render } from "./InvitesTable.vue?vue&type=template&id=095d5b3f&scoped=true"
import script from "./InvitesTable.vue?vue&type=script&lang=js"
export * from "./InvitesTable.vue?vue&type=script&lang=js"

import "./InvitesTable.vue?vue&type=style&index=0&id=095d5b3f&scoped=true&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095d5b3f"]])

export default __exports__